import type { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'
import { RouteSpinner } from '@/components/ui/RouteSpinner'

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    // Query owns caching; the router should not also stale-check loader data.
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: RouteSpinner,
    // Immediate pending UI on client navigations. The library default (1000ms)
    // keeps the previous screen visible, so Kelola → /detail-group never showed
    // RouteSpinner unless the user refreshed (which remounts `_authed`).
    defaultPendingMs: 0,
    defaultPendingMinMs: 0,
    scrollRestoration: true,
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}
